import { render } from "./RenderDatetime.vue?vue&type=template&id=574c27cb&scoped=true"
import script from "./RenderDatetime.vue?vue&type=script&lang=ts"
export * from "./RenderDatetime.vue?vue&type=script&lang=ts"

import "./RenderDatetime.vue?vue&type=style&index=0&id=574c27cb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-574c27cb"

export default script